import { getApiUrl, type OrderDetailResponseDto } from "Infrastructure/Api/Api";
import { LocationOn, Numbers } from "@mui/icons-material";
import { OrderInfoCard, type OrderInfoItem } from "./OrderInfoCard";

type GeneralInfoCardProps = {
	order?: OrderDetailResponseDto;
};

export function GeneralInfoCard({ order }: GeneralInfoCardProps) {
	if (!order) return null;

	const items: OrderInfoItem[] = [
		{
			icon: <Numbers fontSize="small" />,
			value: String(order.id),
			label: "",
			show: !!order.id,
		},
		{
			icon: <LocationOn fontSize="small" />,
			value: order.region?.name,
			label: "",
			show: !!order.region?.name,
		},
		{
			icon: order.vertical?.iconPath ? (
				<img
					src={`${getApiUrl()}${order.vertical.iconPath}`}
					alt="vertical icon"
					width="16px"
					height="16px"
				/>
			) : null,
			value: order.vertical?.name
				?.split(" ")
				.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
				.join(" "),
			label: "",
			show: !!order.vertical?.name,
		},
	];

	return <OrderInfoCard title="General Info" items={items} />;
}
